import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import TableComponent from '@/app/static/table-component.vue';
import { queryElements } from '@/app/shared/utils/content-utils';

@injectable()
export class IncludeTableHandler implements Api.IncludeComponentsHandlerInterface {
  public includeComponents($parsedContent: any): Promise<Vue[]> {

    const elements: any = queryElements('table.table', $parsedContent);
    if (elements === null) {
      return Promise.resolve([]);
    }

    return new Promise((resolve) => {
      $(() => {

        let components: Vue[] = []

        $('table.table', $('.main-container')).each((i, element) => {
          const $element: any = $(element);
          const component: TableComponent = new TableComponent({
            propsData: { 
              table: $element[0] 
            }
          });
          component.$mount();

          $element.replaceWith(component.$el);

          components.push(component)
        });

        resolve(components)
      });

    })
  }
}
